/** Why the desktop didn't start, in words a person reads (the agent's errors are lowercase, for logs): the
 *  Linux-only one said plainly, any other with a capital and a full stop. The Mac's DesktopPane.problem. */
export function desktopProblem(e: string): string {
  if (/only available on a linux/i.test(e)) return 'The desktop runs only on a Linux cloud machine.';
  const t = e.trim();
  return t.charAt(0).toUpperCase() + t.slice(1) + (/[.!?]$/.test(t) ? '' : '.');
}
